import { Button } from '@mui/material';
import React, { useState } from 'react'
import { styled, useTheme } from '@mui/material/styles';
import { GoHome } from "react-icons/go";
import { CiMenuBurger, CiStar, CiUser } from "react-icons/ci";
import { BsCalendarCheck, BsCalendar4Event } from "react-icons/bs";
import { connect } from 'react-redux';
import store from '../store';
import { CHANGE_PAGE_action } from '../store/actions/pageAction';
import { Link } from 'react-router-dom';

import Box from '@mui/material/Box';
// import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { CLOSE_SIDEBAR_action } from '../store/actions/sidebarAction';
import MuiDrawer from '@mui/material/Drawer';

// Iconos 
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import PersonIcon from '@mui/icons-material/Person';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import HomeIcon from '@mui/icons-material/Home';
import MapRoundedIcon from '@mui/icons-material/MapRounded';

const mapStateToProps = (state) => {
  return {
    user: state.userReducer,
    page: state.pageReducer.pageName,
    sidebar: state.sidebarReducer.sidebarState,
    token: state.tokenReducer.token,
  }
}


const openedMixin = (theme) => ({
  width: 240,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)})`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(7)})`,
  },
});

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: 240,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);


const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

const Sidebar = ({page, sidebar, user, token}) => {
  const [sidebarstate, setSidebarstate] = useState(true);
  const [open, setOpen] = useState(false)

  const handleToggleSidebar = () => {
    store.dispatch(CLOSE_SIDEBAR_action())
    setOpen(false);
  };

  const changePage = (item) => {
    
      store.dispatch(CHANGE_PAGE_action(item.title))
      handleToggleSidebar()
    // store.dispatch(CHANGE_PAGE_action(item.title))
  }


  const sidebarItems = [

    { title: 'inicio', 
    HTMLtitle: 'Inicio',
    icon: <HomeIcon 
    size={28} /> },
    // { title: 'mapa', 
    // HTMLtitle: 'Mapa de eventos',
    // icon: <MapRoundedIcon 
    // size={28} /> },

    // { title: (user.email !== '' ? 'aceptados' : 'login'), 
    // HTMLtitle: 'Eventos aceptados',
    // icon: <EventAvailableIcon /> },

    
  ]
  const sidebarPersonalItems = [
    { title: 'invitaciones', 
    HTMLtitle: 'Invitaciones',
    icon: <StarBorderIcon /> },
    { title: 'perfil', 
    HTMLtitle: 'Perfil',
    icon: <PersonIcon /> },
    // { title: 'settings', 
    // HTMLtitle: 'Configuración',
    // icon: <SettingsIcon color={(page == 'settings') ? 'primary' : 'black'} /> },
    { title: 'login', 
    HTMLtitle: 'Cerrar sesión',
    icon: <LogoutIcon /> },
  ]

  

  return (
    <Drawer
        variant="permanent"
        open={sidebar != undefined ? sidebar : open}
      >
        <DrawerHeader>
        </DrawerHeader>
        <Divider />
        <List>
          {sidebarItems.map((item, index) => (
            <ListItem key={index} disablePadding>
              <Link style={{textDecoration: 'none', color: 'black', width: '100%'}} to={(item.title != '' ? '/' + item.title : null)}>
                <ListItemButton onClick={() => {changePage(item)}}>
                  <ListItemIcon>
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText primary={item.HTMLtitle} />
                </ListItemButton>
              </Link>
          </ListItem>
          ))}
          {/* {sidebarItems.map((text, index) => (
            <ListItem key={index} disablePadding>
              <ListItemButton onClick={ handleToggleSidebar}>
                <ListItemIcon>
                  {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          ))} */}
        </List>
        <Divider />
        {(token !== '' && token !== undefined) && (

          <List>
          {sidebarPersonalItems.map((item, index) => (
              <ListItem key={index} disablePadding>
                <Link style={{textDecoration: 'none', color: 'black', width: '100%'}} to={(item.title != '' ? '/' + item.title : null)}>
                  <ListItemButton onClick={() => {changePage(item)}}>
                    <ListItemIcon>
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText primary={item.HTMLtitle} />
                  </ListItemButton>
                </Link>
            </ListItem>
            ))}
          </List>
        )}
        
        {/* <Divider />
        <p style={{fontSize: 10, marginTop: 16, marginLeft:4}}>© 2024 HiSocialize. Todos los derechos reservados.</p> */}
        
      </Drawer>
  )
}


const sidebar = {
  width: 96,
  paddingTop: 64, 
  paddingRight: 32,
  flexDirection: 'column',
  display: 'flex'
}


const sidebarItems = {
  marginVertical: 24, 
  alignItems: 'center'
}


export default connect(mapStateToProps)(Sidebar);
